/**
 * Created by qx on 2018/12/25.
 */
import { get, post, put, remove } from '../../http'
import { _typeof } from '@/global/util/util'

const PLAN_ADVERTISER_MENU = 'PLAN_ADVERTISER_MENU' // 所属广告主下拉菜单
const PLAN_GROUP_ADVERTISER_SELECT_MENU = 'PLAN_GROUP_ADVERTISER_SELECT_MENU' // 所属广告组下拉菜单

const PLAN_FLOW_TYPE_MENU = 'PLAN_FLOW_TYPE_MENU' // 流量类型
const PLAN_PORT_TYPE_MENU = 'PLAN_PORT_TYPE_MENU' // 投放终端
const PLAN_PLACE_ATTRIBUTE_MENU = 'PLAN_PLACE_ATTRIBUTE_MENU' // 广告位属性
const PLAN_PLACES_MENU = 'PLAN_PLACES_MENU' // 广告位下拉菜单
const PLAN_AREA_MENU = 'PLAN_AREA_MENU' // 地域数据
const PLAN_COMMON_ITEM = 'PLAN_COMMON_ITEM'
const PLAN_PAYMENT_MENU = 'PLAN_PAYMENT_MENU' // 结算方式
const state = {
  planManage: {
    advertiserMenu: [],
    flowTypeMenu: [],
    curFlowType: '',
    groupAdverMenu: [],
    portTypeMenu: [],
    curPortType: '',
    placeMenu: [],
    infoFlowStyles: [],
    areaMenu: [],
    crowdOrients: [], // 人群定向
    deviceOrients: [], // 设备定向
    iosDevices: [], // iOS 设备
    androidDevices: [], // android 设备
    bwLists: [], // 黑白名单
    bwItems: [], // 名单选项
    sexs: [], // 性别
    ages: [], // 年龄
    hobbies: [], // 兴趣
    appInterests: [], // 应用兴趣
    games: [],
    stages: [], // 阶段
    educations: [], // 学历
    careers: [], // 职业
    incomes: [], // 收入
    houses: [], // 有房无房
    cars: [], // 有车无车
    ngaOptions: [
      { name: '是', value: 1 },
      { name: '否', value: 0 }
    ], // nga 板块定向
    ngaOrients: [], // nga板块定向内容
    operators: [], // 运营商
    networkWays: [], // 联网方式
    payments: [], // 结算方式
    curPayment: '',
    hourPutControls: [], // 投放控制/时
    carouselRules: [] // 轮播规则
  }
}

const getters = {
  planManage: state => state.planManage
}

const actions = {
  async planItem({ state, commit }, { data, platform }) {
    // 获取通某用列表数据
    let response = await get('/interface/etcd/item/' + data + '?platform=' + platform)
    return response
  },
  async planSelect({ state, commit }, { data, platform }) {
    // 获取计划筛选下拉菜单
    let response = await get(platform + '/global/ads/' + data)
    return response
  },
  async batchStart({ state, commit }, { data, platform } = {}) {
    // 批量开始
    let response = await post(platform + '/global/ads/batchstart', { ...data })
    return response
  },
  async batchStop({ state, commit }, { data, platform } = {}) {
    // 批量开始
    let response = await post(platform + '/global/ads/batchstop', { ...data })
    return response
  },
  async planStop({ state, commit }, { data, platform } = {}) {
    // 停止订单
    let response = await remove(platform + '/global/ads/' + data.ad)
    return response
  },
  async planNameIsRepeat({ state, commit }, { platform, data }) {
    let response = await get(`${platform}/global/ads/is-repeated`, { ...data })
    return response
  },
  async getSuggestPrice({ state, commit }, { platform, data } = {}) {
    let response = await get(platform + '/global/ads/bidding', { ...data })
    return response
  },
  async uploadBwList({ state, commit }, { platform, file } = {}) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await post('/interface/black-white-upload', formData);
    return res;
  },
  async downloadBwTemp({ state, commit, rootState }, { platform }) {
    await get(`/${platform}/global/ads/blackwhite`);
  },
  async getCommonItem({ state, commit }, { params } = {}) {
    const map = {
      is_oriented: { type: 'planManage', value: 'crowdOrients' },
      is_media: { type: 'planManage', value: 'deviceOrients' },
      information: { type: 'planManage', value: 'infoFlowStyles' },
      'media_ids-port_type_1': { type: 'planManage', value: 'iosDevices' },
      'media_ids-port_type_2': { type: 'planManage', value: 'androidDevices' },
      is_black_white: { type: 'planManage', value: 'bwLists' },
      black_white: { type: 'planManage', value: 'bwItems' },
      sex: { type: 'planManage', value: 'sexes' },
      age: { type: 'planManage', value: 'ages' },
      game_type: { type: 'planManage', value: 'games' },
      hobby: { type: 'planManage', value: 'hobbies' },
      app_interest: { type: 'planManage', value: 'appInterests' },
      stages_life: { type: 'planManage', value: 'stages' },
      education: { type: 'planManage', value: 'educations' },
      career: { type: 'planManage', value: 'careers' },
      income: { type: 'planManage', value: 'incomes' },
      house: { type: 'planManage', value: 'houses' },
      car: { type: 'planManage', value: 'cars' },
      operator: { type: 'planManage', value: 'operators' },
      network_way: { type: 'planManage', value: 'networkWays' },
      m_play: { type: 'planManage', value: 'carouselRules' },
      'plan_hour_type_2.5': { type: 'planManage', value: 'hourPutControls' }
    }
    const keys = Object.keys(map)
    const promises = []
    keys.forEach(key => {
      promises.push(get('/interface/etcd/item/' + key))
    })
    await Promise.all(promises).then(data => {
      commit(PLAN_COMMON_ITEM, { result: data, map })
    })
  },
  async planList({ state, commit }, { platform, data }) {
    // 计划列表 / 查看计划
    let response
    if (data && data.planId) {
      response = await get(platform + '/global/ads/' + data.planId)
    } else {
      response = await get(platform + '/global/ads', data)
    }
    return response
  },
  async advertiserList({ state, commit }, { platform, data }) {
    await get(platform + '/order/aduserselect').then(res => {
      if (res.code === 1) {
        commit(PLAN_ADVERTISER_MENU, { result: res.data })
      }
    })
  },
  async getAreaMenu({ state, commit }) {
    await get('/interface/etcd/jsonitem/cities').then(res => {
      if (res.code === 1) {
        commit(PLAN_AREA_MENU, { result: res.data })
      }
    })
  },
  async getNgaOrient({ state, commit }, { data }) {
    const response = await get('/interface/nga/sections', { ...data })
    return response
  },
  async addAds({ state, commit }, { platform, data } = {}) {
    let response = await post(`${platform}/global/ads`, { ...data })
    return response
  },
  async updateAds({ state, commit }, { platform, data, ad } = {}) {
    let response = await put(`${platform}/global/ads/${ad}`, { ...data })
    return response
  },
  async detailsAds({ state, commit }, { platform, data } = {}) {
    const { ad } = data
    let response = await get(`${platform}/global/ads/${ad}`)
    return response
  },
  async groupAdverSelect({ state, commit }, { platform, data }) {
    await get(platform + '/global-order/get-orders-for-ad/' + data.adverId).then(res => {
      if (res.code === 1) {
        commit(PLAN_GROUP_ADVERTISER_SELECT_MENU, { result: res.data })
      }
    })
  },
  async getCommonPlace({ state, commit }, { params, data, api, isAll, mediaType } = {}) {
    await get('/interface/v2.5/place/attribute/' + params, data).then(res => {
      if (res.code === 1) {
        commit(api, { result: res.data, isAll, data })
      }
    })
  }
}

const mutations = {
  [PLAN_ADVERTISER_MENU](state, result) {
    state.planManage.advertiserMenu = result.result
  },
  [PLAN_GROUP_ADVERTISER_SELECT_MENU](state, result) {
    state.planManage.groupAdverMenu = result.result
  },
  [PLAN_FLOW_TYPE_MENU](state, result) {
    state.planManage.flowTypeMenu = result.result
    state.planManage.curFlowType = result.result.length ? result.result[0].value : ''
  },
  [PLAN_PORT_TYPE_MENU](state, result) {
    state.planManage.portTypeMenu = result.result
    state.planManage.curPortType = result.result.length ? result.result[0].value : ''
  },
  [PLAN_PLACE_ATTRIBUTE_MENU](state, result) {
    state.planManage.placeAttrMenu = result.result
    state.planManage.curPlaceAttr = result.result.length ? result.result[0].value : ''
  },
  [PLAN_PLACES_MENU](state, result) {
    state.planManage.placeMenu = result.result
  },
  [PLAN_AREA_MENU](state, result) {
    state.planManage.areaMenu = result.result
  },
  [PLAN_PAYMENT_MENU](state, result) {
    state.planManage.payments = result.result
    state.planManage.curPayment = result.result.length ? result.result[0].value : ''
  },
  [PLAN_COMMON_ITEM](state, { result, map }) {
    let key
    let keys = Object.keys(map)
    for (let [index, value] of result.entries()) {
      key = map[keys[index]]
      if (_typeof(key) === 'object') {
        state[key.type][key.value] = value.data
        continue
      }
      state[key] = value.data
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
